// Definición de defaults

export const defaultSentidoAmparo: SentidoAmparoProps = {
    idSentidoAmparo:    0,
    descripcion:        '',
    activo:             false,
}

// Creación de interfaces

export interface SentidoAmparoProps {
    idSentidoAmparo:        number;
    descripcion:             string;
    activo:                  boolean;
}